import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { shoppingListActions } from '_store';

export { List };

function List() {
    // const shoppingLists = useSelector(x => x.shoppingLists.list);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(shoppingListActions.getAll());
    }, []);

    return (
        <div>
            <h1>Shopping Lists</h1>
            <p>...</p>
            </div>
            );
            
};